import { useBridge } from '../../../application/hooks/useBridge';
import { useState } from 'react';
import { DefaultBox } from '../../etc/LBox/LBox';
import { useRecoilState } from 'recoil';
import * as Atom from '../../../application/recoil';

const TestKt = () => {
  const br: any = useBridge();
  const [isBackKey, setBackKey] = useState<string>('');
  const [userInfo] = useRecoilState(Atom.userInfo);
  const [personal] = useRecoilState(Atom.personalInfo);
  const [issuanceStatus, setIssuanceStatus] = useState();
  const [issuance, setIssuance] = useState();
  const [certSignResult, setCertSignResult] = useState();

  const requestUserCertIssuanceStatus = () => {
    console.log(br);
    br.onReceiveUserCertIssuanceStatus((v: any) => {
      setIssuanceStatus(v);
    });
    br.requestUserCertIssuanceStatus();
  };

  const requestUserCertIssuance = () => {
    br.onReceiveUserCertIssuance((v: any) => {
      setIssuance(v);
    });
    br.requestUserCertIssuance();
  };

  const requestCertSignStandby = () => {
    br.onCertSignResult((v: any) => {
      setCertSignResult(v);
    });
    br.requestCertSignStandby();
  };

  const moveExternalWebBrowser2 = () => {
    console.log('openExternalBrowser');
    br.openExternalBrowser({ url: '//naver.com' });
  };
  const moveExternalWebBrowser = () => {
    console.log('openExternalBrowser');
    br.openExternalBrowser({ url: 'https://naver.com' });
  };
  const moveInternalWebBrowser = () => {
    console.log('openInternalBrowser');
    br.openNativeWebView({
      url: 'https://naver.com',
      title: '대출 비교/테스트',
      closeType: 'B',
    });
  };
  const closeScreen = () => {
    console.log('close');
    br.close();
  };
  const movePassMain = () => {
    console.log('goNativeMain');
    br.goNativeMain();
  };
  const requestCustmer = () => {
    console.log('requestCustomerInfo');
    br.requestCustomerInfo({ thirdLoanYn: 'Y' });
  };
  const requestCustmerN = () => {
    console.log('requestCustomer N Info');
    br.requestCustomerInfo({ thirdLoanYn: 'N' });
  };
  const requestAuth = () => {
    console.log('requestAuthCheck');
    br.requestAuthCheck({ pisAppToken: 'null' });
  };
  const receiveAuthCheck = () => {
    console.log('receiveAuthCheck');
    br.receiveAuthCheck(() => {
      alert('receiveAuthCheck');
    });
  };

  const requestAddService = (type: string, url?: string) => {
    br.requestAddService({ type: type, url: url });
  };

  // 대출비교 중단
  const requestAddServiceToCredit = () => {
    br.requestAddService({
      type: 'CREDIT',
      url: '',
      noneMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCF90`, // 비회원
      freeMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCF90`, // 무료회원
      paidMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCAM1`, // 유료회원
      needMoveAfterJoin: true,
    });
  };

  // 대출비교 하단
  const requestAddServiceToCredit2 = () => {
    br.requestAddService({
      type: 'CREDIT',
      url: '',
      noneMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTCDF10`,
      freeMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTCD000`,
      paidMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCAM1`,
      needMoveAfterJoin: false,
    });
  };

  window.onClickHWKeyBtn = () => {
    console.log('onClickNativeBackKey');
    setBackKey('onClickNativeBackKey');
  };

  return (
    <DefaultBox>
      <h1>bridge interface KT</h1>
      <h4>isBackKey : {isBackKey}</h4>
      <p>app version : {userInfo.version}</p>
      <p>srcCd : {userInfo.srcCd}</p>
      <p>custSeq : {personal.custSeq}</p>
      <p>env : {process.env.REACT_APP_ENV}</p>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
        query : <br />
        {window.location.search}
      </p>
      <p>
        인증서 발급 상태 확인:
        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {JSON.stringify(issuanceStatus)}
        </span>
      </p>
      <p>
        인증서 발급 결과:
        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {JSON.stringify(issuance)}
        </span>
      </p>
      <p>
        인증서 서명 결과:
        <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {JSON.stringify(certSignResult)}
        </span>
      </p>

      <br />
      <>
        <p>{'대출비교 -> 타 서비스 Interface'}</p>
        <div>
          <button
            onClick={() => {
              requestAddServiceToCredit();
            }}
          >
            (대출비교 중간) <br />
            비회원/무료회원 '신용진단'으로 이동
            <br />
            유료회원 '신용지키미'로 이동
          </button>
        </div>

        <div>
          <button
            onClick={() => {
              requestAddServiceToCredit2();
            }}
          >
            (대출비교 하단) <br />
            비회원 '신용진단'로 이동 <br />
            무료/유료 회원 '신용지키미'로 이동
          </button>
        </div>

        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007BA01',
              )
            }
          >
            'EBMP'로 이동 - 대출탭 메인
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007AA01',
              )
            }
          >
            'EBMP'로 이동 - 카드탭 메인
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007CA01',
              )
            }
          >
            'EBMP'로 이동 - 보험탭 메인
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007BB01',
              )
            }
          >
            'EBMP'로 이동 대출탭 내 프로모션 상세
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007BC01',
              )
            }
          >
            'EBMP'로 이동 - 대출탭 내 커스텀 상세
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007AB01',
              )
            }
          >
            'EBMP'로 이동 - 카드탭 내 프로모션 상세
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007AC01',
              )
            }
          >
            'EBMP'로 이동 - 카드탭 내 커스텀 상세
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'EBMP',
                'https://devkt.ebmp.kr/kt/extlink?src_cd=D007CC01',
              )
            }
          >
            'EBMP'로 이동 - 보험탭 내 커스텀 상세
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'MYDATA',
                'https://service.tb.mydata.kt.co.kr/mobile/mdspLogin.kt?redirectUrl=%2Fmobile%2FassetMain.kt%26targetEvent%3DcreditScoreFocus',
              )
            }
          >
            '마이데이터'로 이동 - 신용점수 포커싱
          </button>
        </div>
        <div>
          <button
            onClick={() =>
              requestAddService(
                'MYDATA',
                'https://service.tb.mydata.kt.co.kr/mobile/mdspLogin.kt?redirectUrl=%2Fmobile%2FassetMain.kt%26targetEvent%3DcreditScoreBooster',
              )
            }
          >
            '마이데이터'로 이동 - 신용부스터 상세페이지
          </button>
        </div>
      </>
      <br />
      <p>대출비교 Interface</p>

      <div>
        <button onClick={requestUserCertIssuanceStatus}>
          PASS앱 인증서 발급 상태 확인
        </button>
      </div>
      <div>
        <button onClick={requestUserCertIssuance}>
          PASS앱 인증서 발급 요청
        </button>
      </div>
      <div>
        <button onClick={requestCertSignStandby}>
          PASS앱 인증서 인증서 서명 대기 요청
        </button>
      </div>
      <div>
        <button onClick={moveExternalWebBrowser}>외부 브라우저로 이동</button>
      </div>

      <div>
        <button onClick={moveExternalWebBrowser2}>
          // 외부 브라우저로 이동
        </button>
      </div>
      <div>
        <button onClick={moveExternalWebBrowser}>외부 브라우저로 이동</button>
      </div>
      <div>
        <button onClick={moveInternalWebBrowser}>내부 브라우저로 이동</button>
      </div>
      <div>
        <button onClick={closeScreen}>화면 종료</button>
      </div>
      <div>
        <button onClick={movePassMain}>PASS 메인화면 홈 탭으로 이동</button>
      </div>
      <div>
        <button onClick={requestCustmer}>
          사용자 정보 요청 동의자(테스트페이지에서는 불가)
        </button>
      </div>
      <div>
        <button onClick={requestCustmerN}>
          사용자 정보 요청 미동의자(테스트페이지에서는 불가)
        </button>
      </div>
      <div>
        <button onClick={requestAuth}>
          인증 요청(테스트페이지에서는 불가)
        </button>
      </div>
      <div>
        <button onClick={receiveAuthCheck}>
          인증 체크(테스트페이지에서는 불가)
        </button>
      </div>
    </DefaultBox>
  );
};

export default TestKt;
